import { Component, OnInit, OnDestroy, signal, ChangeDetectionStrategy, inject, WritableSignal } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { interval, Subscription } from "rxjs";
import { DiashowItems } from "../../../types/diashow.type";
import { DIASHOW_ITEMS } from "../../../constants/diashow.constant";
import { IconModule } from "@ogs/ngx-m3-components";
import { TextClampDirective } from "@shared/directives/text-ellipsis/text-clamp.directive";
import { MatButtonModule } from "@angular/material/button";
import { NgClass } from "@angular/common";
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

@Component({
  selector: "app-authenticate-ui-diashow",
  templateUrl: "./diashow.component.html",
  styleUrl: "./diashow.component.scss",
  standalone: true,
  imports: [ IconModule, TextClampDirective, MatButtonModule, NgClass, TranslationPipeModule ],
  providers: [ provideTranslationScope("feature/auth") ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiashowComponent implements OnInit, OnDestroy {
  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  private _intervalSubscription: Subscription | null = null;

  protected readonly DIASHOW_ITEMS: DiashowItems = DIASHOW_ITEMS;

  protected readonly currentDiashowIndex: WritableSignal<number> = signal<number>(0);

  constructor () {
    this._faIconLibrary.addIcons(faChevronLeft, faChevronRight);
  }

  public ngOnInit (): void {
    this._restartDiashow();
  }

  public ngOnDestroy (): void {
    this._intervalSubscription?.unsubscribe();
  }

  private _restartDiashow (): void {
    this._intervalSubscription?.unsubscribe();
    this._intervalSubscription = interval(10_000).subscribe((): void => {
      this.currentDiashowIndex.update((_index: number): number => {
        let index: number = _index;

        ++index;

        return index > this.DIASHOW_ITEMS.length - 1 ? 0 : index;
      });
    });
  }

  protected nextDiashowItem (): void {
    this.currentDiashowIndex.update((_index: number): number => {
      let index: number = _index;

      ++index;

      return index > this.DIASHOW_ITEMS.length - 1 ? 0 : index;
    });
    this._restartDiashow();
  }

  protected previousDiashowItem (): void {
    this.currentDiashowIndex.update((_index: number): number => {
      let index: number = _index;

      --index;

      return index < 0 ? this.DIASHOW_ITEMS.length - 1 : index;
    });
    this._restartDiashow();
  }

  protected setDiashowItemByIndex (index: number): void {
    this.currentDiashowIndex.set(index > this.DIASHOW_ITEMS.length - 1 ? 0 : index);
    this._restartDiashow();
  }
}
